import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SettingsService } from '../../core/settings/settings.service';
import { FamilleRechercheModel } from '../famille/models/famille-recherche.model';
import { FamilleModel } from '../famille/models/famille.model';

@Injectable()
export class FamilleService {

    constructor(private settings: SettingsService, private http: HttpClient) { }


    searchFamille(searchForm: FormGroup, searchModel: FamilleRechercheModel): Observable<any> {
        if (searchForm.controls['id'].value) {
            return searchModel.getResource('default', 'get')
            .call(this.http, 'findById', [searchForm.controls['id'].value, this.settings.getUserSetting('anneeScolaire')])
            .map((data) => {
                let list = [];
                list.push(new FamilleModel(data));

                return list;
            });

        } else {
            return searchModel.getResource('default', 'find')
            .call(this.http, searchForm, [])
            .map((data) => {
                let list = [];

                if (data instanceof Array) {
                    data.forEach((familly) => {
                        list.push(new FamilleModel(familly));
                    });
                }

                return list;
            });
        }
    }


}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/services/famille.service.ts